export default function toAbbreviateString(str: string, showUpTo: number) {
  if (str.length > showUpTo) {
    return `${str.substring(0, showUpTo)}...`;
  }

  return str;
}
